import ProductObservationsActionDropdown from "./ProductObservationsActionDropdown";
import TableCheck from "../TableCheck";
import DateFormatter from "../../DateFormatter";
import { dateFine } from "../../../util/Utilities";

const ProductObservationsColumns = [
    {
        Label: TableCheck,
        Component: TableCheck
    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'N° Guía / Factura',
        Component: ({ value }) => value?.guide_number || '--'
    },
    {
        Label: () => 'N° Orden de Compra',
        Component: ({ value }) => value?.purchase_order_number || '--'
    },
    {
        Label: () => 'Proveedor',
        Component: ({ value }) => value?.provider?.name || '--'
    },
    {
        Label: () => 'Solicitante',
        Component: ({ value }) => value?.user?.name || '--'
    },
    {
        Label: () => 'Elaborado por',
        Component: ({ value }) => value?.createdBy?.name || '--'
    },
    {
        Label: () => 'Productos',
        Component: ({ value }) => (
            <span className="badge bg-primary text-white">
                {value?.products_count || 0} prod.
            </span>
        )
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    },
    {
        Label: () => 'Acciones',
        Component: ProductObservationsActionDropdown
    }
];

export default ProductObservationsColumns;
